import React from 'react';
import { formatClientCode } from '../../../utils/formatClientCode';
import { formatLocalDate } from '../../../utils/formatDate';
import { reduceName } from '../../../utils/reduceName';

export default function NpsTable({ data, onView }) {
    const getNpsCategory = (score) => {
        if (score >= 9) return { className: 'nps-promoter', label: 'Promoter' };
        if (score >= 7) return { className: 'nps-passive', label: 'Passive' };
        return { className: 'nps-detractor', label: 'Detractor' };
    };

    const getRatingClass = (value) => {
        if (value === 3) return 'bg-green-100 text-green-800';
        if (value === 2) return 'bg-indigo-100 text-indigo-800';
        if (value === 1) return 'bg-yellow-100 text-yellow-800';
        return 'bg-red-100 text-red-800';
    };

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Motorista</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Filial</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Criador</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Notas</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center">NPS</th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                    </tr>
                </thead>


                <tbody id="npsTableBody" className="bg-white divide-y divide-gray-200">
                    {data.map((item) => {
                        const { className, label } = getNpsCategory(item.npsScore);

                        return (
                            <tr key={item.id} className="hover:bg-gray-50 hover:cursor-pointer" onClick={() => onView(item)}>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center">
                                            <i className="fas fa-user text-blue-600"></i>
                                        </div>
                                        <div className="ml-4">
                                            <div className="text-sm font-medium text-gray-900">{item.clientName}</div>
                                            <div className="text-sm text-gray-500">Código: {formatClientCode(item.clientCode).substring(5)}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-900">{reduceName(item.driverName)}</div>
                                    <div className="text-sm text-gray-500">{item.driverId.substring(4)}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-900">{item.branchName}</div>
                                    <div className="text-sm text-gray-500">{item.branchCode}</div>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-900">{item.employeeName}</div>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex space-x-1">
                                        <div className={`rating-badge px-2 py-1 rounded ${getRatingClass(item.teamApproach)}`}>{item.teamApproach}</div>
                                        <div className={`rating-badge px-2 py-1 rounded ${getRatingClass(item.storageCheck)}`}>{item.storageCheck}</div>
                                        <div className={`rating-badge px-2 py-1 rounded ${getRatingClass(item.productQuality)}`}>{item.productQuality}</div>
                                        <div className={`rating-badge px-2 py-1 rounded ${getRatingClass(item.issueResolution)}`}>{item.issueResolution}</div>
                                        <div className={`rating-badge px-2 py-1 rounded ${getRatingClass(item.deliveryTime)}`}>{item.deliveryTime}</div>
                                    </div>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap text-center">
                                    <span className={`nps-score font-bold px-2 py-1 rounded ${className}`}>{item.npsScore}</span>
                                    <div className="text-xs text-gray-500 mt-1 text-center">{label}</div>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-900">{formatLocalDate(item.createdAt)}</div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
